import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'permission'

const PermissonModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default PermissonModule



// WEBPACK FOOTER //
// ./src/store/module/permission/index.js